import { sortByKey } from './utils';
import { cloneStatuses } from './statuses';

const cloneStatusOrder = [
    cloneStatuses.beingCreated,
    cloneStatuses.online,
    cloneStatuses.offline,
    cloneStatuses.missing
];

const cloneStatusIndex = (cloneStatus) => {
    const index = cloneStatusOrder.indexOf(cloneStatus);
    return index < 0 ? cloneStatusOrder.length : index;
};

const cloneSortKey = (clone) => {
    return cloneStatusIndex(clone.status.state);
};

export const filterAndSortClones = (clones) => {
    const result = Array.from(clones)
                        .filter(c => c.status.state !== cloneStatuses.deleted);
    sortByKey(result, cloneSortKey);
    return result;
};



// WEBPACK FOOTER //
// ./src/js/cloneFilter.js